import React, { useState } from 'react';
import { Alert, Card, Form } from 'antd';

import Headline from '../../../UI/Headline/Headline';
import TrailForm from '../TrailForm/TrailForm';
import TrailService from '../../../../Services/api/TrailService';

function CreateTrail({ companyId }) {
    const [form] = Form.useForm();
    const [error, setError] = useState('');

    const addTrailHandler = async (trail) => {
        try {
            setError('');
            const payload = { ...trail, companyId: Number(companyId) };
            // console.log(payload);
            await TrailService.create(payload);
            window.location.href = '/admin/routes';
        } catch (err) {
            const msg = err.response.data.message;
            setError(msg);
            console.log(err);
            console.log(err.response);
            console.log(err.response.data);
            console.log(err.response.data.message);
        }
    };

    return (
        <Card bordered>
            <Headline title="Dodaj trasę" />
            <TrailForm
                form={form}
                saving={false}
                loading={false}
                mode="new"
                successHandler={addTrailHandler}
                submitButtonText="Dodaj trasę"
            />
            {error && (
                <Alert type="error" message={error} style={{ marginTop: 10 }} />
            )}
        </Card>
    );
}

export default CreateTrail;
